export default __webpack_public_path__ + "static/media/zurich.8615f9a9.jpg";